import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles";
import OrganisationUserLookup from '../../../Common/Models/OrganisationUserLookup';
import { AppService, Types } from '../../StaticData/StaticDataTypes';
import OrganisationUserSearchCriteria from '../../../Common/Models/OrganisationUserSearchCriteria';
import OrganisationUser from '../../../Common/Models/OrganisationUser';

export default class OrganisationUserPagedCatalogueEntry extends Catalogue.PagedCatalogueEntry<OrganisationUserSearchCriteria, OrganisationUserLookup, OrganisationUser> {

    constructor(private apiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        private taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super("Organisation Users", OrganisationUserSearchCriteria, OrganisationUserLookup, OrganisationUser, {
            sortBy: "organisationName",
            fetchInitial: true,
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
        });
    }

    public organisations = this.apiClient.getStaticOrganisationList().then((res) => {
        return res.data;
    });

    public users = this.apiClient.getUsers().then((res) => {
        return res.data;
    });

    public get editRole() {
        return Roles.OrganisationConfigurationsRoles.Edit;
    }

    public getPagedDataEndpoint() {
        return this.apiClient.getOrganisationUsers;
    }

    public getSaveEndpoint() {
        return this.apiClient.saveOrganisationUser;
    }

    public renderCriteria(criteria: OrganisationUserSearchCriteria, meta: Model.TransformMetaType<OrganisationUserSearchCriteria>) {
        return (
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup label="Organisation Name" bind={meta.organisationName} />
                <Neo.FormGroup label="User Name" bind={meta.userName} />
            </Neo.GridLayout>
        )
    }

    public renderRow(item: OrganisationUserLookup, meta: Model.TransformMetaType<OrganisationUserLookup>) {
        return (
            <NeoGrid.RowGroup>
                <NeoGrid.Row>
                    <NeoGrid.Column display={meta.organisationName} />
                    <NeoGrid.Column display={meta.userName} />
                    <NeoGrid.ButtonColumn deleteButton={{ onClick: () => this.removeItem(this.taskRunner, item) }} />
                </NeoGrid.Row>
            </NeoGrid.RowGroup>
        );
    }

    public renderFormControls(item: OrganisationUser, meta: Model.TransformMetaType<OrganisationUser>) {
        return <div>
            <Neo.GridLayout md={3}>
                <Neo.FormGroup
                    bind={meta.organisationId}
                    select={{ items: this.organisations, displayMember: "organisationName", valueMember: "organisationId" }}>
                </Neo.FormGroup>
                <Neo.FormGroup
                    bind={meta.userId}
                    select={{ items: this.users, displayMember: "userName", valueMember: "userId" }} >
                </Neo.FormGroup>
            </Neo.GridLayout>
        </div>
    }
}